import React from 'react';

import {
  Grid,
  Divider,
} from '@material-ui/core';

import classes from '../../css/print.css';
import ganeshImage from '../../assets/img/ganesh.jpg';


const printPreview = (props) => {
  let extraFields = null;

  if (props.profile.personalinfo.marital_status.value === 5
      || props.profile.personalinfo.marital_status.value === 6) {
    extraFields = (
      <Grid container spacing={8} style={{ marginTop: '5px' }}>
        <Grid item md={6} sm={6} xs={6}>
          <table className={classes.tableBordered} width="100%">
            <tbody>
              <tr>
                <td width="50%">DIVORCED/WIDOWED YEAR:</td>
                <td width="50%">{props.profile.personalinfo.marriage_end_year}</td>
              </tr>
              <tr>
                <td width="30%">NO. OF YEARS OF MARRIAGE:</td>
                <td width="70%">{props.profile.personalinfo.marriage_years_count}</td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item md={6} sm={6} xs={6}>
          <table className={classes.tableBordered} width="100%">
            <tbody>
              <tr>
                <td width="30%">CHILDREN:</td>
                <td width="70%">{props.profile.personalinfo.children}</td>
              </tr>
              <tr>
                <td width="30%">LEGAL INFO:</td>
                <td width="70%">{props.profile.personalinfo.legal}</td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    );
  }

  let selfAddress = null;
  if (props.profile.contactinfo.self_address
      && props.profile.contactinfo.self_city
      && (props.profile.is_editable
          || props.profile.interest.received
          || props.profile.request.received
          || props.profile.interest.accepted
          || props.profile.request.accepted)
  ) {
    selfAddress = (
      <tr>
        <td width="15%">CANDIDATE ADDRESS:</td>
        <td colSpan="3">
          {props.profile.contactinfo.self_address}, &nbsp;
          {props.profile.contactinfo.self_city.label}
        </td>
      </tr>
    );
  }

  let contactinfo = null;
  if (props.profile.is_editable
      || props.profile.interest.received
      || props.profile.request.received
      || props.profile.interest.accepted
      || props.profile.request.accepted
  ) {
    contactinfo = (
      <React.Fragment>
        <tr>
          <td width="15%">FAMILY RESIDENCE ADDRESS:</td>
          <td colSpan="3">
            {props.profile.contactinfo.family_address}, &nbsp;
            {props.profile.contactinfo.family_city.label}
          </td>
        </tr>
        <tr>
          <td width="25%">LOCATION:</td>
          <td width="25%" className={classes.tableRightBorder}>{props.profile.contactinfo.location}</td>
          <td width="25%">RESIDENCE TYPE:</td>
          <td width="25%">{props.profile.contactinfo.residence_type.label}</td>
        </tr>
        <tr>
          <td width="25%">NO. OF ROOMS:</td>
          <td width="25%" className={classes.tableRightBorder}>{props.profile.contactinfo.rooms_count} BHK</td>
          <td width="25%">AREA IN SQFT:</td>
          <td width="25%">{props.profile.contactinfo.residence_area} sq.ft.</td>
        </tr>
        <tr>
          <td width="20%">RESIDENCE CONTACT NO.:</td>
          <td colSpan="3">{props.profile.contactinfo.residence_phone}</td>
        </tr>
        <tr>
          <td width="25%">{'FATHER\'S CONTACT NO.'}:</td>
          <td width="25%" className={classes.tableRightBorder}>{props.profile.contactinfo.father_contact}</td>
          <td width="25%">{'MOTHER\'S CONTACT NO.'}:</td>
          <td width="25%">{props.profile.contactinfo.mother_contact}</td>
        </tr>
      </React.Fragment>
    );
  }

  let partnerChoice = null;

  if (props.profile.partnerchoice) {
    partnerChoice = (
      <React.Fragment>
        <Grid item md={12} sm={12} xs={12}>
          <table className={classes.tableBordered} width="100%">
            <tbody>
              <tr>
                <td colSpan="4">{'PARTNER\'S CHOICE'}</td>
              </tr>
              <tr>
                <td width="15%">AGE:</td>
                <td width="35%" className={classes.tableRightBorder}>{props.profile.partnerchoice.from_age} to {props.profile.partnerchoice.to_age}</td>
                <td width="15%">HEIGHT:</td>
                <td width="35%">{props.profile.partnerchoice.from_height} to {props.profile.partnerchoice.to_height}</td>
              </tr>
              <tr>
                <td width="15%">MARITAL STATUS:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  <span className={classes.limitCell}>
                    {props.profile.partnerchoice.marital_status}
                  </span>
                </td>
                <td width="15%">CASTE:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  <span className={classes.limitCell}>
                    {props.profile.partnerchoice.caste}
                  </span>
                </td>
              </tr>
              <tr>
                <td width="15%">QUALIFICATIONS:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  <span className={classes.limitCell}>
                    {props.profile.partnerchoice.qualification
                      ? props.profile.partnerchoice.qualification
                      : 'Any'}
                  </span>
                </td>
                <td width="15%">PROFESSION:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  <span className={classes.limitCell}>
                    {props.profile.partnerchoice.profession
                      ? props.profile.partnerchoice.profession
                      : 'Any'}
                  </span>
                </td>
              </tr>
              <tr>
                <td width="15%">INCOME:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  <span className={classes.limitCell}>
                    {props.profile.partnerchoice.income
                      ? props.profile.partnerchoice.income
                      : 'Any'}
                  </span>
                </td>
                <td width="15%">HOROSCOPE:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  {props.profile.partnerchoice.horoscope
                    ? props.profile.partnerchoice.horoscope
                    : 'Any'}
                </td>
              </tr>
              <tr>
                <td width="15%">DIET:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  {props.profile.partnerchoice.diet
                    ? props.profile.partnerchoice.diet.label
                    : 'Any'}
                </td>
              </tr>
              <tr>
                <td width="15%">SMOKE:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  {props.profile.partnerchoice.smoke
                    ? props.profile.partnerchoice.smoke.label
                    : 'Any'}
                </td>
                <td width="15%">DRINK:</td>
                <td width="35%" className={classes.tableRightBorder}>
                  {props.profile.partnerchoice.drink
                    ? props.profile.partnerchoice.drink.label
                    : 'Any'}
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </React.Fragment>
    );
  }

  return (
    <div className={classes.page}>
      <div className={classes.subpage}>
        <Grid container>
          <Grid item md={4} sm={4} xs={4}>
            <img src={ganeshImage} alt="print" style={{ height: '40px' }} />
            <table width="100%">
              <tbody>
                <tr>
                  <td width="30%">Profile ID:</td>
                  <td>{props.profile.profile_id}</td>
                </tr>
                <tr>
                  <td width="30%">Joined on:</td>
                  <td>{props.profile.date_joined}</td>
                </tr>
                <tr>
                  <td width="30%">Branch:</td>
                  <td>{props.profile.site.name}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          {/* <Grid item md={8} sm={8} xs={8} align="right">
            <h1 className={classes.noMargin}>Anjal ane Avsar</h1>
            <p className={classes.noMargin}>
              27, Chandan Mahal Co-Op. Socy. Ltd., <br /> 11th Road, Santacruz-East, Mumbai 400055
            </p>
            <p className={classes.noMargin}>
              www.anjalavsar.com | support@anjalavsar.com
            </p>
            <p className={classes.noMargin}>Mob No.: 9869009363 Tel. No.: 2663 0152</p>
            <p className={classes.noMargin}>Time: Mon. to Fri. 11:00 am to 1:00 pm</p>
          </Grid> */}
        </Grid>
        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
        <table className={classes.tableBordered} width="100%">
          <tbody>
            <tr>
              <td width="15%">NAME:</td>
              <td colSpan="3">{props.profile.basicinfo.first_name} {props.profile.basicinfo.last_name}</td>
            </tr>
            <tr>
              <td width="15%">MARITAL STATUS:</td>
              <td width="35%" className={classes.tableRightBorder}>{props.profile.personalinfo.marital_status.label}</td>
              <td width="15%">CASTE:</td>
              <td width="35%">{props.profile.personalinfo.caste.label}</td>
            </tr>
          </tbody>
        </table>
        {extraFields}
        <Grid container spacing={8} style={{ marginTop: '5px' }}>
          <Grid item md={6} sm={6} xs={6}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="30%">DATE OF BIRTH:</td>
                  <td width="70%">{props.profile.personalinfo.birth_date}</td>
                </tr>
                <tr>
                  <td width="30%">TIME OF BIRTH:</td>
                  <td width="70%">{props.profile.personalinfo.birth_time}</td>
                </tr>
                <tr>
                  <td width="30%">PLACE OF BIRTH:</td>
                  <td width="70%">{props.profile.personalinfo.birth_place.label}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="30%">HEIGHT:</td>
                  <td width="70%">{props.profile.personalinfo.height}</td>
                </tr>
                <tr>
                  <td width="30%">WEIGHT:</td>
                  <td width="70%">{props.profile.personalinfo.weight} kgs</td>
                </tr>
                <tr>
                  <td width="30%">BODY TYPE:</td>
                  <td width="70%">{props.profile.lifestyleinfo.body_type.label}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="30%">DIET:</td>
                  <td width="70%">{props.profile.lifestyleinfo.diet.label}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="30%">SMOKE:</td>
                  <td width="70%">{props.profile.lifestyleinfo.smoke.label}</td>
                </tr>
                <tr>
                  <td width="30%">DRINK:</td>
                  <td width="70%">{props.profile.lifestyleinfo.drink.label}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="15%">QUALIFICATION:</td>
                  <td width="35%" className={classes.tableRightBorder}>{props.profile.educationinfo.qualification.label}</td>
                  <td width="15%">PROFESSION:</td>
                  <td width="35%">{props.profile.educationinfo.profession.label}</td>
                </tr>
                <tr>
                  <td width="15%">DEGREES:</td>
                  <td colSpan="3">{props.profile.educationinfo.degree}</td>
                </tr>
                <tr>
                  <td width="15%">WORK PROFILE:</td>
                  <td width="35%" className={classes.tableRightBorder}>{props.profile.educationinfo.work_profile.label}</td>
                  <td width="15%">INCOME:</td>
                  <td width="35%">{props.profile.educationinfo.income.label}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="30%">{'FATHER\'S NAME'}:</td>
                  <td width="70%">{props.profile.familyinfo.father_name}</td>
                </tr>
                <tr>
                  <td width="30%">{'MOTHER\'S NAME'}:</td>
                  <td width="70%">{props.profile.familyinfo.mother_name}</td>

                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="50%">{'FATHER\'S OCCUPATION'}:</td>
                  <td width="50%">{props.profile.familyinfo.father_occupation.label}</td>
                </tr>
                <tr>
                  <td width="50%">{'MOTHER\'S OCCUPATION'}:</td>
                  <td width="50%">{props.profile.familyinfo.mother_occupation.label}</td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="15%">MOSAL (SURNAME):</td>
                  <td width="35%" className={classes.tableRightBorder}>{props.profile.familyinfo.mosal}</td>
                  <td width="15%">{'NANAJI\'S NAME'}:</td>
                  <td width="35%">{props.profile.familyinfo.nanaji}</td>
                </tr>
                <tr>
                  <td width="15%">NATIVE PLACE:</td>
                  <td colSpan="3">{props.profile.familyinfo.native_place}</td>
                </tr>
                <tr>
                  <td width="15%">BROTHERS:</td>
                  <td width="35%" className={classes.tableRightBorder}>
                    Total: {props.profile.familyinfo.brother_count},
                    Married: {props.profile.familyinfo.brother_married}
                  </td>
                  <td width="15%">SISTERS:</td>
                  <td width="35%" className={classes.tableRightBorder}>
                    Total: {props.profile.familyinfo.sister_count},
                    Married: {props.profile.familyinfo.sister_married}
                  </td>
                </tr>
              </tbody>
            </table>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                {selfAddress}
                {contactinfo}
              </tbody>
            </table>
          </Grid>
          {partnerChoice}
          <Grid item md={12} sm={12} xs={12}>
            <table className={classes.tableBordered} width="100%">
              <tbody>
                <tr>
                  <td width="25%">REFERRED BY:</td>
                  <td width="25%" className={classes.tableRightBorder}>{props.profile.referenceinfo.name}</td>
                  <td width="25%">CONTACT NO.:</td>
                  <td width="25%">{props.profile.referenceinfo.phone}</td>
                </tr>
              </tbody>
            </table>
          </Grid>

        </Grid>

      </div>
    </div>
  );
};

export default printPreview;



// WEBPACK FOOTER //
// ./src/profile/components/PrintPreview.js